<template>

  <v-select
      prepend-inner-icon="store"
      :items="items"
      :item-text="'name'"
      :item-value="'id'"
      v-model="item"
      :label="$t('delivery.stock.labels.branch')"
      :loading="loading"
      :error="hasInputErrors('branch')"
      :error-messages="getInputErrors('branch')"
      color="secondary"
      item-color="secondary"
      :rules="required"
      :hide-details="hideDetails"
      :solo="solo"
      :clearable="clearable"
      :dense="dense"
      :returnObject="returnObject"
      class="mx-1"
  ></v-select>

</template>

<script>

import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'


import BranchProvider from "../../providers/BranchProvider"

export default {
  name: "BranchCombobox",
  mixins: [InputErrorsByProps, RequiredRule],
  props: {
    value: {type: [String, Object]},
    hideDetails: {type: Boolean, default: false},
    solo: {type: Boolean, default: false},
    clearable: {type: Boolean, default: false},
    dense: {type: Boolean, default: false},
    returnObject: {type: Boolean, default: false}
  },
  data() {
    return {
      items: [],
      loading: false
    }
  },
  computed: {
    item: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  mounted() {
    this.fetch()
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    fetch() {
      this.loading = true
      BranchProvider.fetchBranch().then(r => {
        this.items = r.data.fetchBranch
      }).catch(err => console.error(err))
          .finally(() => this.loading = false)
    }

  }
}
</script>

<style scoped>

</style>

